import { PropertyType } from './property-type.enum';
import { ObjectValue } from '../../../models/object-value.model';
import { EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';


export class SchemaForm {
    Rows: SchemaFormRow[] = [];
}

export class SchemaFormRow {
    Columns: Schema[] = [];
}

export class SchemaColumn {
    constructor(description: string, propertyName: string, values: ObjectValue[] = []) {
       this.Description = description;
       this.PropertyName = propertyName;
       this.Values = values;
    }

    Description: string;
    PropertyName: string;
    Values?: ObjectValue[];
}

export class SchemaConfiguration {
    attributes: any;
    disabled = false;
    required = false;
    mask: string;
    cancelUpperCase = false;
    IconSufix: SchemaIcon;
    messageValidation: string;
    additionalText: string;
}

export class Schema extends SchemaColumn {

    constructor(
        description: string,
        propertyName: string,
        type: PropertyType,
        values: ObjectValue[] = [],
        configuration: Partial<SchemaConfiguration> = {}) {

        super(description, propertyName, values);

        this.Type = type;
        this.Disabled = configuration.disabled;
        this.Required = configuration.required;
        this.Attributes = configuration.attributes;
        this.Mask = configuration.mask;
        this.AdditionalText = configuration.additionalText;
        this.CancelUpperCase = configuration.cancelUpperCase;
        this.IconSufix = configuration.IconSufix;
        this.MessageValidation = !configuration.messageValidation ?  'Campo obrigatório' : configuration.messageValidation;
    }

    Type: PropertyType;
    Attributes: any;
    Disabled = false;
    Required = false;
    Mask: string;
    CancelUpperCase = true;
    IconSufix: SchemaIcon;
    AdditionalText: string;

    MessageValidation: string;
    OnValueChange: EventEmitter<any> = new EventEmitter<any>();
    ElementRef: any;
}

export class SchemaIcon {
  constructor(name: string, type: IconTypeEnum, clickable: boolean = false) {
    this.Name = name;
    this.Type = type;
    this.Clickable = clickable;
    this.OnClick = new EventEmitter<MouseEvent>();
  }

  Name: string;
  Clickable: boolean;
  Type: IconTypeEnum;
  OnClick: EventEmitter<MouseEvent>;
  ELementRef: any;
}

export enum IconTypeEnum {
  MaterialDesing,
  FontAwesome
}
